import apiMiddleware from "../../../api/apiMiddleware";

export const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `package-enquiries?page=${page}${search ? `&search=${search}` : ''}`
  );
  return response.data;
};

export const search = async ({ search, page = 1 }) => {
  const response = await apiMiddleware.get(
    `package-enquiries?search=${search}&page=${page}`
  );
  return response.data;
};

// get by id
export const getById = async (id) => {
  const response = await apiMiddleware.get(`package-enquiry/${id}`);
  return response.data;
};

// Mark enquiry as read
export const markAsRead = async (id) => {
  const response = await apiMiddleware.post(`package-enquiry/${id}`);
  return response.data;
};

